import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import React from "react";

export const Profile = ({doctor, isLoggedIn}) => {
    return <MDBox id="profile">
        <MDBox mt={2}>
            <MDTypography variant="h5">Información de Perfil</MDTypography>
            <MDTypography variant="body2" mt={1} sx={{fontSize: 14}}>{doctor?.short_description}</MDTypography>
        </MDBox>
        <MDBox mt={2}>
            <Grid container>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Lugar de Trabajo:</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.business_name}</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Dirección:</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.business_address}</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Teléfono:</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.business_phone}</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Especialidad:</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.specialty}</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Correo:</MDTypography>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.business_email}</MDTypography>
                </Grid>
            </Grid>
        </MDBox>
        {
            isLoggedIn &&
            <>
                <MDBox mt={4}>
                    <MDTypography variant="h5">Información Bancaria</MDTypography>
                </MDBox>
                <MDBox mt={2}>
                    <Grid container>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Banco:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.bank}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Clabe:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.bank_account}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Correo Bancario:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.account_email}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Nombre Titular:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.account_name}</MDTypography>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox mt={4}>
                    <MDTypography variant="h5">Información Personal</MDTypography>
                </MDBox>
                <MDBox mt={2}>
                    <Grid container>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Dirección:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.address}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Teléfono:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.phone}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>Correo Bancario:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.email}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 14}}>RFC:</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <MDTypography variant="body2" sx={{fontSize: 14}}>{doctor?.rfc}</MDTypography>
                        </Grid>
                    </Grid>
                </MDBox>
            </>
        }
    </MDBox>
}
